import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {MobileCheck} from "../../services/mobile-check/mobile-check.service";
import {CommonModule} from "@angular/common";
import {SharedModule} from "../../shared/shared.module";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'colimo-credits-page',
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule
  ],

  templateUrl: './credits-page.component.html',
  styleUrl: './credits-page.component.scss'
})
export class CreditsPageComponent implements OnInit, OnDestroy  {

  public isMobile: boolean;
  private stop$: Subject<boolean> = new Subject();

  constructor(private mobileCheck: MobileCheck) { }

  ngOnInit(): void {
    this.mobileCheck.getScreenSize().pipe(takeUntil(this.stop$)).subscribe((device) => {
      this.isMobile = device.isMobile;
    });
  }

  public ngOnDestroy(): void {
    this.stop$.next(true);
    this.stop$.unsubscribe();
  }
}
